<template>
  <v-container tag="section" fluid>
    <base-material-card
      color="primary"
      icon="mdi-cog-outline"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Configurações Regulatórias
        </div>
      </template>

      <v-row class="mx-auto mt-5">
        <v-col cols="12">
          <v-switch
            v-model="config.possui_linhas_distribuicao"
            label="Empresa possui Linhas de Distribuição (TEC_LD)"
            :loading="loading"
          />
        </v-col>
        <v-col cols="12">
          <v-switch
            v-model="config.possui_subestacoes"
            label="Empresa possui Subestações (TEC_SUB)"
            :loading="loading"
          />
        </v-col>
        <v-col cols="12">
          <v-switch
            v-model="config.possui_meta_plpt"
            label="Empresa possui meta PLpT (serviço 102)"
            :loading="loading"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto" justify="end">
        <v-col cols="auto">
          <v-btn
            color="success"
            min-width="100"
            :loading="loading"
            @click="salvar()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import CompanyIndgerConfigService from "@/services/CompanyIndgerConfigService";

  export default {
    name: "CompanyIndgerConfigIndex",
    data() {
      return {
        loading: false,
        config: {
          possui_linhas_distribuicao: true,
          possui_subestacoes: true,
          possui_meta_plpt: true,
        },
      };
    },
    async mounted() {
      await this.getConfig();
    },
    methods: {
      async getConfig() {
        this.loading = true;

        try {
          this.config = await CompanyIndgerConfigService.getConfig();
        } catch (error) {
          console.error(error);
          this.$toast.error("Ocorreu um erro ao buscar a configuração", "", {
            position: "topRight",
          });
        } finally {
          this.loading = false;
        }
      },
      async salvar() {
        this.loading = true;

        try {
          this.config = await CompanyIndgerConfigService.update({
            possui_linhas_distribuicao: this.config.possui_linhas_distribuicao,
            possui_subestacoes: this.config.possui_subestacoes,
            possui_meta_plpt: this.config.possui_meta_plpt,
          });

          this.$toast.success("Configuração salva com sucesso.", "", {
            position: "topRight",
          });
        } catch (error) {
          console.error(error);
          this.$toast.error("Ocorreu um erro ao salvar a configuração", "", {
            position: "topRight",
          });
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
